import { changeLocale } from 'client/actions'
import Select from 'client/components/core/Sidebar/components/Settings/components/Select'
import { localeNames } from 'common/constants/localeTypes'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'

const LanguageSelector = ({ changeLocaleConnected, locale }) => (
  <div>
    <GroupTitle>language</GroupTitle>
    <Select
      update={changeLocaleConnected}
      choiceList={localeNames}
      labelText="choose language"
      value={locale}
    />
  </div>
)

LanguageSelector.propTypes = {
  changeLocaleConnected: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
}

const mapStateToProps = ({
  page: {
    present: { locale },
  },
}) => ({ locale })
const mapDispatchToProps = { changeLocaleConnected: changeLocale }

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector)
